import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-drawer-header',
  templateUrl: './drawer-header.component.html',
  styleUrls: ['./drawer-header.component.scss'],
  standalone: false
})
export class DrawerHeaderComponent {
  @Input() title: string;
  @Input() modalId: string;
  @Input() shouldShowHeaderBorder: boolean;
  @Input() shouldShowSwiper: boolean;

  @Output() onHeaderSwipeDown: EventEmitter<any> = new EventEmitter<any>();
  @Output() onPanEnd: EventEmitter<any> = new EventEmitter<any>();
  @Output() onModalClose: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('header') headerElement: ElementRef;

  swipeDown(event: any): void {
    this.onHeaderSwipeDown.emit(event);
  }

  panEnd(): void {
    this.onPanEnd.emit();
  }

  close(): void {
    this.onModalClose.emit();
  }
}
